export default __webpack_public_path__ + "static/media/3.f0f7d613.png";